import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failedSolutions = [{
    title: 'Tarjetas de puntos',
    description: 'No ahorran dinero; te obligan a gastar más para darte un beneficio marginal.'
  }, {
    title: 'Comprar "lo que falta" en el negocio de la esquina',
    description: 'Gasto hormiga es un 30% más caro que una compra planificada.'
  }, {
    title: 'Seguir las ofertas de la televisión',
    description: 'Te hace comprar productos premium que no necesitas para tu nutrición diaria.'
  }, {
    title: 'No usar el congelador estratégicamente',
    description: 'Es tirar un tercio de tu sueldo a la basura cada semana.'
  }];
  return <section className="w-full bg-[#1a2332] py-16 px-4" data-id="element-48">
      <div className="max-w-5xl mx-auto" data-id="element-49">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-50">
          Lo que ya intentaste (y por qué no funcionó)
        </h2>

        <div className="space-y-4" data-id="element-51">
          {failedSolutions.map((solution, index) => <div key={index} className="bg-[#243447] rounded-lg p-6 flex items-start gap-4 hover:bg-[#2a3d52] transition-colors" data-id="element-52">
              <XCircleIcon className="w-6 h-6 text-[#ef4444] flex-shrink-0 mt-1" data-id="element-53" />
              <div data-id="element-54">
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-55">
                  {solution.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-56">
                  {solution.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}